export const en = {
    "k_76a4befc": "CosId does not exist",
    "k_c6ccb06f": "[npm-loader] Initialization failed: {arg_0}",
    "k_b9262cc2": "Project dependence information",
    "k_63ac58d4": "Modify the version number and save it to update. The version-changes here are project-level",
    "k_c40b5468": "You cannot add/remove dependency here, you need to add or remove references from the source code to take effect",
    "k_94905b98": "Please note:",
    "k_d97f9efc": "Return",
    "k_ff2e0c04": "Update dependency",
    "k_b6620c6e": "❌ Unable to find a dependent package for the specified version: {arg_0}",
    "k_eb5afed0": "❌ Unable to find a dependent package for the specified version",
    "k_7eb7e72e": "❌ The requested dependency package version does not exist",
    "k_c9968070": "❌ {arg_0} may not exist. Please check whether the package name is wrong",
    "k_60012c69": "❌ The specified dependency cannot be found. Please check whether the package name is wrong",
    "k_cebc7377": "📦Installing dependency packages...",
    "k_a4b5e666": "❌ Dependent package installation failed",
    "k_9a6cb7bf": "⚡ Packaging dependent files...",
    "k_df14598c": "❌ Packaging of dependent files failed",
    "k_af282eed": "✅ Depends on updates to complete",
    "k_cca46ec5": "❌ Dependent update failed",
    "k_1662ff42": "Processing...",
    "k_ffc90dad": "Wuji blue",
    "k_837e1a2b": "Dependency update failed: {arg_0}",
    "k_e394ca14": "Dependency update detected, building new dependency file...",
    "k_c8f16779": "Dependency update failed, please check whether the external package name is wrong"
};
